import Header from "../Header";
import AdminPanelSideBar from "./AdminPanelSideBar";
import Footer from "../Footer";
import AdminPostsNav from "../Posts/AdminPostsNav";
import { NavLink, useLocation } from "react-router-dom";

const AdminPanel = () => {
    const location= useLocation();
  return (
    <>
      <Header />
      <div className="below-header">
        <p>
          <NavLink to={"/"}>Home</NavLink>
          <span>/</span>
          <a href={location.pathname} className="aCustom">All Posts</a>
        </p>
      </div>
      <div className="flex-screen custom_section">
        <AdminPanelSideBar />
        <AdminPostsNav />
      </div>
      <Footer />
    </>
  );
};

export default AdminPanel;
